export const checksums = {
  "index": "v3.5.0--nEqfXAVXmKXqHLCyVOVa_32zvjT0ZMXsFYGqwDuQZ9M",
  "docs": "v3.5.0--T3JDcp0A0rvK8ZDn0V0xUwA1TJQiQQyHFo6VP613YVw",
  "blog": "v3.5.0--65CSwKixqvvX7HDaR7c9GO6tuwgrnLgsaTpcMw9A0Ak",
  "landing": "v3.5.0--hz8RK-Pm872emuuoskCUJdNQwLg5qyz8Vmotgm2upFM",
  "deploy": "v3.5.0--WtwnS80UDfAcw4HtsTLBavOdsmuRachFbEjomniRveE",
  "support": "v3.5.0--PTGbkKlMWBj2Uj_Fe9NB-C2HMichmmEq-Dtg3B0uGaA",
  "agencies": "v3.5.0--4aQuF5adCrXfuyMwV2Ovo94AroLmTWEj1L-6nwhyWp0",
  "templates": "v3.5.0--ZXsxnKwbGKBPge4X3H253AbK1gmsLX2XSKGnf3MIubE",
  "videoCourses": "v3.5.0--0IKemrUfFTFw0RbRkBzz2GWqc2N_idq2ersqV3x54Us",
  "designKit": "v3.5.0--axpyVRqLFeIt1Zs3qtabEJoO8jLFMaePLFTBCESsiks",
  "team": "v3.5.0--RwVnfZ4Jqqi3zFTqUzrgdwc-OFU7_LF5P8ozK1q6uEc"
}
export const checksumsStructure = {
  "index": "rbMG1eOiUTNGy_xyk9VPcrt70I6t8ckzwxQB33q9CGk",
  "docs": "Cl2XZ9UuM2VkXN05ktyeqVpSjE5zOk-ACJxbHmNHDjc",
  "blog": "RJa1bT6mb-TLun5xXRwQzQO2OiM574yv3efcV9uHQpM",
  "landing": "45t9gA5AR33S7rbn2z7_FfTJ_XN4FF052AXq67uPcrE",
  "deploy": "PSPDIoGKVQgVA3vA67GTmyfUK6DM_qcZ4VLapjn7MXA",
  "support": "euT2wOQwCvsmZlUf2kN5TQrPUAgcNPAPR4klmLsG13w",
  "agencies": "Y0pqttVW9cRvpf_OAzMbaaJ4T_wnpq_2U6ue4lukic8",
  "templates": "ccHyzsY6NYdRC_TN742UXcW62TYfYPq_X0WfvDRUnSs",
  "videoCourses": "ZIQVDRKochrfBo7eZiBodkaxfXJw0SelxKtmWX7EqsA",
  "designKit": "c1_WWfrYTvLNHL_kLbdOQBOaeQKbA3V1JgHgvkHDrwk",
  "team": "fROx0lpAG2F7LelhEMtsAxifeY8fRDRLmWArYlns4rU"
}

export const tables = {
  "index": "_content_index",
  "docs": "_content_docs",
  "blog": "_content_blog",
  "landing": "_content_landing",
  "deploy": "_content_deploy",
  "support": "_content_support",
  "agencies": "_content_agencies",
  "templates": "_content_templates",
  "videoCourses": "_content_videoCourses",
  "designKit": "_content_designKit",
  "team": "_content_team",
  "info": "_content_info"
}

export default {
  "index": {
    "type": "data",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "hero": "json",
      "logos": "json",
      "features": "json",
      "foundation": "json",
      "modules": "json",
      "testimonial": "json",
      "deploy": "json",
      "contributors": "json",
      "stats": "json",
      "support": "json",
      "sponsors": "json"
    }
  },
  "docs": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "titleTemplate": "string",
      "links": "json"
    }
  },
  "blog": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "image": "string",
      "authors": "json",
      "date": "string",
      "draft": "boolean",
      "category": "string",
      "tags": "json"
    }
  },
  "landing": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "image": "json",
      "head": "json",
      "headline": "json",
      "links": "json",
      "cta": "json"
    }
  },
  "deploy": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "componentImg": "string",
      "logoSrc": "string",
      "featured": "boolean",
      "logoIcon": "string",
      "category": "string",
      "nitroPreset": "string",
      "website": "string"
    }
  },
  "support": {
    "type": "data",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "title": "string",
      "description": "string",
      "hero": "json",
      "logos": "json",
      "service": "json",
      "expertise": "json",
      "testimonials": "json",
      "project": "json",
      "form": "json"
    }
  },
  "agencies": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "logo": "json",
      "logoFull": "string",
      "link": "string",
      "services": "json",
      "resources": "json",
      "emailAddress": "string",
      "phoneNumber": "string",
      "x": "string",
      "github": "string",
      "linkedin": "string",
      "instagram": "string",
      "color": "json",
      "regions": "json",
      "location": "string"
    }
  },
  "templates": {
    "type": "data",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "name": "string",
      "slug": "string",
      "description": "string",
      "repo": "string",
      "demo": "string",
      "purchase": "string",
      "featured": "boolean",
      "badge": "string",
      "screenshotUrl": "string",
      "screenshotOptions": "json"
    }
  },
  "videoCourses": {
    "type": "data",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "name": "string",
      "slug": "string",
      "description": "string",
      "url": "string",
      "badge": "string",
      "screenshotUrl": "string",
      "screenshotOptions": "json",
      "sponsor": "boolean"
    }
  },
  "designKit": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "image": "json",
      "head": "json",
      "headline": "json",
      "links": "json",
      "cta": "json"
    }
  },
  "team": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "image": "json",
      "head": "json",
      "headline": "json",
      "links": "json",
      "cta": "json",
      "users": "json"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}